import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function OfferBlock() {
  return <section id="offer-section" className="bg-navy py-24 px-4 relative" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <FadeIn data-id="element-146">
          <div className="border-2 border-copper p-8 md:p-16 text-center relative bg-navy-light/20 shadow-2xl" data-id="element-147">
            {/* Decorative corners */}
            <div className="absolute top-0 left-0 w-8 h-8 border-t-4 border-l-4 border-copper -translate-x-1 -translate-y-1" data-id="element-148" />
            <div className="absolute top-0 right-0 w-8 h-8 border-t-4 border-r-4 border-copper translate-x-1 -translate-y-1" data-id="element-149" />
            <div className="absolute bottom-0 left-0 w-8 h-8 border-b-4 border-l-4 border-copper -translate-x-1 translate-y-1" data-id="element-150" />
            <div className="absolute bottom-0 right-0 w-8 h-8 border-b-4 border-r-4 border-copper translate-x-1 translate-y-1" data-id="element-151" />

            <h2 className="text-3xl md:text-5xl font-heading font-bold text-cream mb-6 leading-tight" data-id="element-152">
              Secure your inheritance and <br className="hidden md:block" data-id="element-153" />{' '}
              stop the stress.
            </h2>

            <p className="text-xl text-cream font-body mb-10 max-w-2xl mx-auto" data-id="element-154">
              No subscriptions, no hidden fees—just the tactical map you need to
              save the estate from a financial crash.
            </p>

            <div className="mb-10" data-id="element-155">
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-156">
                <span className="text-3xl md:text-4xl font-heading font-bold text-white line-through decoration-2" data-id="element-157">
                  $27
                </span>
                <span className="text-6xl md:text-7xl font-heading font-bold text-copper drop-shadow-lg" data-id="element-158">
                  $6.39
                </span>
              </div>
              <span className="inline-block bg-copper/20 text-copper font-body text-sm px-4 py-1 uppercase tracking-widest border border-copper/30" data-id="element-159">
                Limited-Time Offer — Save 76%
              </span>
            </div>

            <Button href="https://www.shopdilore.com/cart/53793048920374:1" className="w-full md:w-auto md:px-12 py-5 text-xl shadow-glow" data-id="element-160">
              Get the Survival Kit Now
            </Button>

            <p className="mt-6 text-cream font-body text-sm md:text-base" data-id="element-161">
              Instantly download your PDF & Checklist Bundle.
              <br data-id="element-162" />
              <strong className="text-copper font-normal" data-id="element-163">
                Secure the house tonight.
              </strong>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}